<template>
  <el-container class="up-main">
    <el-aside width="211px">
      <left-menu :active="3"></left-menu>
    </el-aside>
    <el-main class="u-main">
      <el-form ref="form" :model="form" label-width="120px" label-position="left" :rules="rules">
        <el-form-item class="w-70" label="公告方" prop="userName">
          <el-input v-model.trim="form.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="业务场景" prop="sceneType">
          <el-select v-model.trim="form.sceneType" placeholder="请选择业务场景" style="width: 100%">
            <el-option v-for="dict in sceneOptions" :key="dict.dictValue" :label="dict.dictLabel"
              :value="dict.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公告标题" prop="title">
          <el-input v-model.trim="form.title" placeholder="请输入公告标题" />
        </el-form-item>
        <el-form-item label="客户经理姓名" prop="managerName">
          <el-input v-model.trim="form.managerName" placeholder="请输入客户经理姓名" />
        </el-form-item>
        <el-form-item label="公告正文" prop="remark">
          <editor v-model.trim="form.remark" :desc="form.remark" :isClear="isClear"></editor>
        </el-form-item>
        <el-form-item label="认刊书" prop="authUrlList" :rules="[{ required: true, message: '请上传', trigger: 'change' }]">
          <el-upload class="upload-part" :limit="1" :action="action" :headers="headers" :before-upload="beforeUpload"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'authUrlList')"
            :on-success="(response, file, list) => upload(response, file, list, 'authUrlList')"
            :file-list="form.authUrlList">
            <el-button size="small" type="blue">上传</el-button>
            <span style="font-size: 10px; color: #999999;margin-left: 10px;">文件大小不超过50M</span>
          </el-upload>
          <a href="./file/【认刊书模板】中国发展网财经频道拍卖公告认刊书0816.doc" download>认刊书模板下载</a>
        </el-form-item>
        <!-- 付款方式 -->
        <el-form-item label="付款方式" prop="payType">
          <el-radio-group v-model="form.payType" :disabled="id.length>0">
            <el-radio-button label="online" >线上支付</el-radio-button>
            <el-radio-button label="offline" >线下支付</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div v-if="form.payType == 'offline'">
          <el-form-item label="付款凭证" prop="payUrlList" :rules="[{ required: true, message: '请上传', trigger: 'change' }]">
            <el-upload class="upload-part" :limit="1" :action="action" :headers="headers" :before-upload="beforeUpload"
              :on-remove="(file, fileList) => handleRemove(file, fileList, 'payUrlList')"
              :on-success="(response, file, list) => upload(response, file, list, 'payUrlList')"
              :file-list="form.payUrlList">
              <el-button size="small" type="blue">上传</el-button>
              <span style="font-size: 10px; color: #999999;margin-left: 10px;">文件大小不超过50M</span>
            </el-upload>
          </el-form-item>
        </div>
        <div v-if="form.payType == 'online'">
          <!--  -->
          <el-form-item label="公示公告费(元)" prop="payAmount" :rules="[{ required: true, message: '请输入公示公告费', trigger: 'blur' }]">
            <el-input-number style="width: 250px;" v-model="form.payAmount" precision="2" :min="0.01" :controls="false" placeholder="请输入您所需支付的公示公告费"></el-input-number>
          </el-form-item>
        </div>
      </el-form>
      <div class="cenrer">
        <el-button class="s-but" type="blue" @click="reportPreview" :loading="butLoading">预 览</el-button>
        <el-button class="s-but" type="blue" @click="submitForm" :loading="butLoading" v-if="id.length>0"> {{'提 交'}}</el-button>
        <el-button class="s-but" type="blue" @click="submitForm" :loading="butLoading" v-else> {{form.payType=='offline'?'提 交':'去支付'}}</el-button>
      </div>
    </el-main>

    <!--预览-->
    <el-dialog title="公告预览" :visible.sync="previewVisible" :close-on-click-modal="false">
      <div class="p-notice">
        <h3>【】：{{ form.title }}</h3>
        <div class="n-tag">公告方承诺：本公告所载信息的真实性、准确性、完整性、合法性及有效性，由{{ form.userName }}承担。中国发展网及运营方不承担责任。</div>
        <div class="n-con" v-html="form.remark"></div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="previewVisible = false" style="height: 40px">确定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import leftMenu from './components/leftMenu'
import editor from '@/components/Editor/wangEdit'
import baseUrl from '@/api/baseUrl.js'
 function childConsole(url){
        console.log(url,'iframe外')
      }
export default {
  name: "addNotice",
  components: {
    leftMenu,
    editor
  },
  data() {
    return {
      isClear: false,//清除富文本编辑器内容
      // 表单参数
      form: {
        payType:'online',
        payAmount: undefined,
      },
      // 表单校验
      rules: {
        userName: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        sceneType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        title: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        remark: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        payType:[
          { required: true, message: "请选择", trigger: "change" }
        ],
      },
      headers: {},
      action: '',
      file: '',
      description: '',
      butLoading: false,
      memberFormVisible: false,
      filters: {},
      dataList: [],
      listLoading: false,
      currentRow: {},
      radioId: null,
      evidenceId: null,
      sceneOptions: [
        {
          dictLabel: "拍卖",
          dictValue: "1"
        }
      ],
      account: sessionStorage.account,
      id: this.$route.query.id || '',
      previewVisible: false,
      loading: null
    }
  },
  created() {
    this.action = `${baseUrl.newucUrl}/iacc-notice/arbitrate/uploadArbitrationApplicationNew`;
    this.getInf() 
    this.getDetail()
   
  },
  methods: {
    getDetail() {
      if (this.id != "") {
        this.$api.api.getNoticePubById({ id: this.id }).then(response => {
          this.form = response.data
          this.form.authUrlList = JSON.parse(this.form.authUrl)
          this.form.payUrlList = JSON.parse(this.form.payUrl)
        });
      }
    },
    childConsole(url){
        console.log(url,'iframe内')
    },
    getInf() {
      this.$api.api.getInfoByAccount({ account: this.account }).then(response => {
        if (response.data.companyType == '01') {
          this.$alert('您还不是机构用户，谢谢！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push({ path: `/release` });
            }
          });
        }
        this.form.userId = response.data.account
        this.form.creatorName = response.data.companyCn
        this.form.creator = response.data.account
        this.$set(this.form, 'userName', response.data.companyCn)
      });
    },
    // 预览
    reportPreview() {
      this.previewVisible = true
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.butLoading = true;
          this.form.source = "PC官网"
          this.form.sourceTag = 'zssj'
          this.form.authUrl = JSON.stringify(this.form.authUrlList)
          this.form.payUrl = JSON.stringify(this.form.payUrlList)
          if (this.id) {
            this.$api.api.updateNoticePub(JSON.stringify(this.form)).then(response => {
              if (response.code == 200) {
                this.butLoading = false;
                this.$message.success("提交成功");
                this.$router.go(-1);
              } else {
                this.butLoading = false;
                this.$message.error(response.msg);
              }
            });
          } else {
            if(this.form.payType=='online'){
              this.form.callBackUrl= window.location.host + window.location.pathname +'#/release'
              // this.form.callBackUrl= 'https://www.zdchain.cn/mine'
            }
            this.$api.api.saveNoticePub(JSON.stringify(this.form)).then(response => {
              if (response.code == 200) {
                if(this.form.payType=='online'){
                    // window.open(response.data) 
                    window.location.href = response.data
                }else{
                  this.butLoading = false;
                  this.$message.success("提交成功");
                  this.$router.go(-1);
                }
              } else {
                this.butLoading = false;
                this.$message.error(response.msg);
              }
            });
          }

        }
      })
    },

    handleError(err, file, fileList) {
      this.$message.error(file.name + "文件上传失败");
    },
    upload(response, file, list, name) {
      this.loading.close();
      if (response.code == 200) {
        this.$set(this.form, name, [{
          name: file.name,
          url: response.data.path,
          hash: response.data.hash
        }])
      } else {
        this.$message.error(file.name + "文件上传失败");
        this.$set(this.form, name, [])
      }
    },
    handleRemove(file, fileList, name) {
      this.$set(this.form, name, [])
    },
    beforeUpload(file) {

      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const isLt2M = file.size / 1024 / 1024 <= 50     //这里做文件大小限制

      if (!isLt2M) {
        this.loading.close();
        this.$message.error('上传文件大小不能超过 50MB！');
      }
      return isLt2M
    },
    rowClick(row) {
      this.radioId = row.account;
    },
    handleCurChange(val) {
      this.currentRow = val;
    },
  }
}
</script>

<style lang="less">
@import '../style.less';

.el-form-item__content {
  z-index: 99;
}

.p-notice {
  h3 {
    text-align: center;
  }

  .n-tag {
    text-indent: 2em;
  }

  .n-con {
    margin-top: 40px;
  }

  p {
    line-height: 24px;
  }
  .el-radio-button__orig-radio:disabled:checked+.el-radio-button__inner {
    background-color: #409EFF !important;
  }
}
</style>
